import * as React from 'react';

import * as styles from './Sidebar.css';
import { ETestId } from '../../../common/constants';
import { DESKTOP_SIDEBAR_WIDTH } from '../../../common/constants/desktopSidebar';

interface ISidebarProps {
  children: React.ReactNode;
  opened: boolean;
}

export const Sidebar: React.FC<ISidebarProps> = ({ children, opened }) => {
  return (
    <div
      data-testid={ETestId.Sidebar}
      className={styles['container']}
      style={{ width: DESKTOP_SIDEBAR_WIDTH } as React.CSSProperties}
      aria-hidden={!opened}
    >
      <div id={ETestId.ListingBody} />
      {children}
    </div>
  );
};

Sidebar.displayName = 'Sidebar';
